import React from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { ShieldCheck } from 'lucide-react';
import { Button } from '@getro/rombo';
import { trackEvent } from 'helpers/analytics';

export const SuccessMessageBanner = () => (
  <Box>
    <Box
      sx={{
        position: 'relative',
        borderRadius: '4px',
        background:
          'linear-gradient(78deg, rgba(73, 0, 255, 0.03) -32.23%, rgba(212, 0, 255, 0.03) 40.71%, rgba(255, 146, 87, 0.03) 125.48%), #FFF',
        mb: '24px',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: '4px',
          padding: '1px',
          background: 'linear-gradient(78deg, #4900FF -32.23%, #D400FF 40.71%, #FF9257 125.48%), #FFF',
          mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          maskComposite: 'exclude',
          overflow: 'hidden',
        },
      }}
    >
      <Flex
        sx={{
          gap: '24px',
          p: '16px',
          flexDirection: 'column',
          fontSize: '14px',
        }}
      >
        <Flex
          sx={{
            gap: '8px',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <Text
            sx={{
              background: 'linear-gradient(94deg, #4900FF 3.21%, #D400FF 63.82%, #FF9257 134.26%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              textAlign: 'center',
              fontSize: '12px',
              fontStyle: 'italic',
              fontWeight: '600',
              lineHeight: '16px',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              mb: '4px',
            }}
          >
            Private Beta feature
          </Text>

          <Text
            as="p"
            sx={{
              fontWeight: '600',
              fontSize: '16px',
              color: 'text.dark',
            }}
          >
            Get hire-ready candidates with Getro&apos;s AI Recruiter
          </Text>

          <Text
            as="p"
            sx={{
              fontWeight: '500',
            }}
          >
            Our new AI Recruiter actively finds, engages, and qualifies candidates for you. Before they ever hit your
            inbox.
          </Text>
        </Flex>

        <Flex
          sx={{
            gap: '8px',
            flexDirection: 'column',
          }}
        >
          <Text as="p">How does it work?</Text>
          <Box as="ol" sx={{ paddingInlineStart: '24px', margin: 0, 'li:not(:last-child)': { mb: '4px' } }}>
            <Box as="li">You calibrate with the agent what &quot;good&quot; looks like</Box>
            <Box as="li">
              <Text as="span" sx={{ fontWeight: '500' }}>
                AI Recruiter
              </Text>{' '}
              finds and engages qualified passive talent outside your network
            </Box>
            <Box as="li">
              <Text as="span" sx={{ fontWeight: '500' }}>
                AI Recruiter
              </Text>{' '}
              screens in real conversation
            </Box>
            <Box as="li">
              <Text as="span" sx={{ fontWeight: '500' }}>
                You only speak to candidates that are ready to be hired
              </Text>
            </Box>
          </Box>
        </Flex>
        <Button
          as="a"
          href="https://scheduler.zoom.us/maveric/30-mins-hire-ready-candidates"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('ai_agents:early_access_click')}
          sx={{ width: '100%', justifyContent: 'center' }}
        >
          Request early access
        </Button>
        <Button
          as="a"
          size="small"
          href="https://cdn.prod.website-files.com/65eeeab8b17e4a53aed92ecb/69660cc5622d94b064d11e15_Hire-Ready%20Candidates%20-%20Getro%20Pilot%20Brief.pdf"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('ai_agents:learn_more_click')}
          variant="tertiary"
          sx={{ bg: 'transparent', justifyContent: 'center', mt: '-8px' }}
        >
          Learn more
        </Button>
      </Flex>
    </Box>

    <Flex sx={{ gap: '8px' }}>
      <Box as={ShieldCheck} size="16px" sx={{ color: 'purple.400', flexShrink: 0, mt: '4px' }} />
      <Text sx={{ fontSize: '14px', fontWeight: '500' }}>
        Risk-free pilot: if we don&apos;t deliver 3–5 hire-ready candidates, you get a full refund.
      </Text>
    </Flex>
  </Box>
);
